import React, { useState } from 'react'

const ChangeForm = () => {
    const [state, setState] = useState({
        first_name: '',
        middle_name: '',
        last_name: '',
        username: '',
        email: '',
        mobile_number: '',
        gender: '',
        bio: '',
        version: "16.8",
        selectedLevel: "Male",
        hooks: ""
    })

    const changeCase = (e) => {
        e.preventDefault();
        const value = e.target.value.toUpperCase()
        setState({
            ...state,
            [e.target.name]: value
        });
    }

    const handleChange = (e) => {
        const value = e.target.value.toUpperCase()
        console.log(value)
        setState({
            ...state,
            [e.target.name]: value
        });
    }
    const handleChecked = (e) => {

        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        setState({
            ...state,
            [e.target.name]: value
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(state)
    }

    return (
        <>
            <section className="content-header">
                <h1>OnChange Form</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">

                        <form onSubmit={handleSubmit}>
                            <div className="panel panel-success panel-br-4">
                                <div className="panel-heading">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h4 className="panel-title">
                                                <i className="fa fa-file-text" aria-hidden="true"></i>
                                                <span>PERSONAL INFORMATION</span>
                                            </h4>
                                        </div>
                                        <div className="col-sm-3" style={{ display: "flex" }}>
                                            <a className="btn btn-warning mr-10">
                                                <span>Save new order</span>
                                            </a>
                                            <a className="btn btn-warning">
                                                <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                        <div className="col-sm-3">
                                            <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                                <i className="fa fa-plus-circle"></i>
                                                <span>Create new document</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div className="panel-body">
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="first_name">
                                            <abbr aria-label="required"> First Name</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                title="required"
                                                aria-label="required"
                                                id="first_name"
                                                name="first_name"
                                                placeholder="FirstName"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.first_name}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="middle_name">
                                            <abbr aria-label="required"> Middle Name</abbr>
                                            <strong style={{ color: "red" }}></strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="middle_name"
                                                name="middle_name"
                                                placeholder="Middle name"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                value={state.middle_name}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="last_name">
                                            <abbr aria-label="required"> Last Name</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="last_name"
                                                name="last_name"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Last Name"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.last_name}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="gender">
                                            <abbr aria-label="required"> Gender</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <select
                                                type="text"
                                                id="gender"
                                                name="gender"
                                                title="required"
                                                aria-label="required"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.gender}
                                                onChange={handleChange}
                                                className="form-control"
                                            >
                                                <option value="">Select Gender</option>
                                                <option value='MALE'>MALE</option>
                                                <option value='FEMALE'>FEMALE</option>
                                            </select>
                                        </div>

                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="mobile_number">
                                            <abbr aria-label="required"> Mobile Number</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="number"
                                                id="mobile_number"
                                                name="mobile_number"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Mobile Number"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.mobile_number}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="email">
                                            <abbr aria-label="required"> Email</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Email Address"
                                                autoComplete='off'
                                                required
                                                value={state.email}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="username">
                                            <abbr aria-label="required"> Username</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="username"
                                                name="username"
                                                placeholder="Auto Generated Username"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.username}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-success panel-br-4">
                                <div className="panel-heading">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h4 className="panel-title">
                                                <i className="fa fa-file-text" aria-hidden="true"></i>
                                                <span>PERSONAL INFORMATION</span>
                                            </h4>
                                        </div>
                                        <div className="col-sm-3" style={{ display: "flex" }}>
                                            <a className="btn btn-warning mr-10">
                                                <span>Save new order</span>
                                            </a>
                                            <a className="btn btn-warning">
                                                <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                        <div className="col-sm-3">
                                            <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                                <i className="fa fa-plus-circle"></i>
                                                <span>Create new document</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div className="panel-body">
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="first_name">
                                            <abbr aria-label="required"> First Name</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                title="required"
                                                aria-label="required"
                                                id="first_name"
                                                name="first_name"
                                                placeholder="FirstName"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.first_name}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="middle_name">
                                            <abbr aria-label="required"> Middle Name</abbr>
                                            <strong style={{ color: "red" }}></strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="middle_name"
                                                name="middle_name"
                                                placeholder="Middle name"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                value={state.middle_name}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="last_name">
                                            <abbr aria-label="required"> Last Name</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="last_name"
                                                name="last_name"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Last Name"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.last_name}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="username">
                                            <abbr aria-label="required"> Username</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="username"
                                                name="username"
                                                placeholder="Auto Generated Username"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.username}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="mobile_number">
                                            <abbr aria-label="required"> Mobile Number</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="number"
                                                id="mobile_number"
                                                name="mobile_number"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Mobile Number"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.mobile_number}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="email">
                                            <abbr aria-label="required"> Email</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Email Address"
                                                autoComplete='off'
                                                required
                                                value={state.email}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="gender">
                                            <abbr aria-label="required"> Gender</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <select
                                                type="text"
                                                id="gender"
                                                name="gender"
                                                title="required"
                                                aria-label="required"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.gender}
                                                onChange={handleChange}
                                                className="form-control" >
                                                <option value="">Select Gender</option>
                                                <option value='MALE'>MALE</option>
                                                <option value='FEMALE'>FEMALE</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-success panel-br-4">
                                <div className="panel-heading">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h4 className="panel-title">
                                                <i className="fa fa-file-text" aria-hidden="true"></i>
                                                <span>PERSONAL INFORMATION</span>
                                            </h4>
                                        </div>
                                        <div className="col-sm-3" style={{ display: "flex" }}>
                                            <a className="btn btn-warning mr-10">
                                                <span>Save new order</span>
                                            </a>
                                            <a className="btn btn-warning">
                                                <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                        <div className="col-sm-3">
                                            <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                                <i className="fa fa-plus-circle"></i>
                                                <span>Create new document</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div className="panel-body">
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="first_name">
                                            <abbr aria-label="required"> First Name</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                title="required"
                                                aria-label="required"
                                                id="first_name"
                                                name="first_name"
                                                placeholder="FirstName"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.first_name}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="middle_name">
                                            <abbr aria-label="required"> Middle Name</abbr>
                                            <strong style={{ color: "red" }}></strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="middle_name"
                                                name="middle_name"
                                                placeholder="Middle name"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                value={state.middle_name}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="last_name">
                                            <abbr aria-label="required"> Last Name</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="last_name"
                                                name="last_name"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Last Name"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.last_name}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="username">
                                            <abbr aria-label="required"> Username</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="username"
                                                name="username"
                                                placeholder="Auto Generated Username"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.username}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="mobile_number">
                                            <abbr aria-label="required"> Mobile Number</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="number"
                                                id="mobile_number"
                                                name="mobile_number"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Mobile Number"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.mobile_number}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="email">
                                            <abbr aria-label="required"> Email</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Email Address"
                                                autoComplete='off'
                                                required
                                                value={state.email}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="gender">
                                            <abbr aria-label="required"> Gender</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <select
                                                type="text"
                                                id="gender"
                                                name="gender"
                                                title="required"
                                                aria-label="required"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.gender}
                                                onChange={handleChange}
                                                className="form-control" >
                                                <option value="">Select Gender</option>
                                                <option value='MALE'>MALE</option>
                                                <option value='FEMALE'>FEMALE</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-success panel-br-4">
                                <div className="panel-heading">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h4 className="panel-title">
                                                <i className="fa fa-file-text" aria-hidden="true"></i>
                                                <span>PERSONAL INFORMATION</span>
                                            </h4>
                                        </div>
                                        <div className="col-sm-3" style={{ display: "flex" }}>
                                            <a className="btn btn-warning mr-10">
                                                <span>Save new order</span>
                                            </a>
                                            <a className="btn btn-warning">
                                                <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                        <div className="col-sm-3">
                                            <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                                <i className="fa fa-plus-circle"></i>
                                                <span>Create new document</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div className="panel-body">
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="first_name">
                                            <abbr aria-label="required"> First Name</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                title="required"
                                                aria-label="required"
                                                id="first_name"
                                                name="first_name"
                                                placeholder="FirstName"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.first_name}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="middle_name">
                                            <abbr aria-label="required"> Middle Name</abbr>
                                            <strong style={{ color: "red" }}></strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="middle_name"
                                                name="middle_name"
                                                placeholder="Middle name"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                value={state.middle_name}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="last_name">
                                            <abbr aria-label="required"> Last Name</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="last_name"
                                                name="last_name"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Last Name"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.last_name}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="username">
                                            <abbr aria-label="required"> Username</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="username"
                                                name="username"
                                                placeholder="Auto Generated Username"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.username}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="mobile_number">
                                            <abbr aria-label="required"> Mobile Number</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="number"
                                                id="mobile_number"
                                                name="mobile_number"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Mobile Number"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.mobile_number}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="email">
                                            <abbr aria-label="required"> Email</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Email Address"
                                                autoComplete='off'
                                                required
                                                value={state.email}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="gender">
                                            <abbr aria-label="required"> Gender</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <select
                                                type="text"
                                                id="gender"
                                                name="gender"
                                                title="required"
                                                aria-label="required"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.gender}
                                                onChange={handleChange}
                                                className="form-control" >
                                                <option value="">Select Gender</option>
                                                <option value='MALE'>MALE</option>
                                                <option value='FEMALE'>FEMALE</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-success panel-br-4">
                                <div className="panel-heading">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h4 className="panel-title">
                                                <i className="fa fa-file-text" aria-hidden="true"></i>
                                                <span>PERSONAL INFORMATION</span>
                                            </h4>
                                        </div>
                                        <div className="col-sm-3" style={{ display: "flex" }}>
                                            <a className="btn btn-warning mr-10">
                                                <span>Save new order</span>
                                            </a>
                                            <a className="btn btn-warning">
                                                <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                        <div className="col-sm-3">
                                            <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                                <i className="fa fa-plus-circle"></i>
                                                <span>Create new document</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div className="panel-body">
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="first_name">
                                            <abbr aria-label="required"> First Name</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                title="required"
                                                aria-label="required"
                                                id="first_name"
                                                name="first_name"
                                                placeholder="FirstName"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.first_name}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="middle_name">
                                            <abbr aria-label="required"> Middle Name</abbr>
                                            <strong style={{ color: "red" }}></strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="middle_name"
                                                name="middle_name"
                                                placeholder="Middle name"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                value={state.middle_name}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="last_name">
                                            <abbr aria-label="required"> Last Name</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="last_name"
                                                name="last_name"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Last Name"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.last_name}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="username">
                                            <abbr aria-label="required"> Username</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="username"
                                                name="username"
                                                placeholder="Auto Generated Username"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.username}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="mobile_number">
                                            <abbr aria-label="required"> Mobile Number</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="number"
                                                id="mobile_number"
                                                name="mobile_number"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Mobile Number"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.mobile_number}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="email">
                                            <abbr aria-label="required"> Email</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Email Address"
                                                autoComplete='off'
                                                required
                                                value={state.email}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="gender">
                                            <abbr aria-label="required"> Gender</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <select
                                                type="text"
                                                id="gender"
                                                name="gender"
                                                title="required"
                                                aria-label="required"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.gender}
                                                onChange={handleChange}
                                                className="form-control" >
                                                <option value="">Select Gender</option>
                                                <option value='MALE'>MALE</option>
                                                <option value='FEMALE'>FEMALE</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-success panel-br-4">
                                <div className="panel-heading">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h4 className="panel-title">
                                                <i className="fa fa-file-text" aria-hidden="true"></i>
                                                <span>PERSONAL INFORMATION</span>
                                            </h4>
                                        </div>
                                        <div className="col-sm-3" style={{ display: "flex" }}>
                                            <a className="btn btn-warning mr-10">
                                                <span>Save new order</span>
                                            </a>
                                            <a className="btn btn-warning">
                                                <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                        <div className="col-sm-3">
                                            <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                                <i className="fa fa-plus-circle"></i>
                                                <span>Create new document</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div className="panel-body">
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="first_name">
                                            <abbr aria-label="required"> First Name</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                title="required"
                                                aria-label="required"
                                                id="first_name"
                                                name="first_name"
                                                placeholder="FirstName"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.first_name}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="middle_name">
                                            <abbr aria-label="required"> Middle Name</abbr>
                                            <strong style={{ color: "red" }}></strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="middle_name"
                                                name="middle_name"
                                                placeholder="Middle name"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                value={state.middle_name}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="last_name">
                                            <abbr aria-label="required"> Last Name</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="last_name"
                                                name="last_name"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Last Name"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.last_name}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="username">
                                            <abbr aria-label="required"> Username</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                id="username"
                                                name="username"
                                                placeholder="Auto Generated Username"
                                                autoComplete='off'
                                                onKeyUp={changeCase}
                                                required
                                                value={state.username}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="mobile_number">
                                            <abbr aria-label="required"> Mobile Number</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="number"
                                                id="mobile_number"
                                                name="mobile_number"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Mobile Number"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.mobile_number}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="email">
                                            <abbr aria-label="required"> Email</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                title="required"
                                                aria-label="required"
                                                placeholder="Email Address"
                                                autoComplete='off'
                                                required
                                                value={state.email}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="gender">
                                            <abbr aria-label="required"> Gender</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <select
                                                type="text"
                                                id="gender"
                                                name="gender"
                                                title="required"
                                                aria-label="required"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.gender}
                                                onChange={handleChange}
                                                className="form-control" >
                                                <option value="">Select Gender</option>
                                                <option value='MALE'>MALE</option>
                                                <option value='FEMALE'>FEMALE</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="bio">
                                            <abbr aria-label="required"> Biography</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <textarea
                                                type="text"
                                                id="bio"
                                                name="bio"
                                                title="required"
                                                aria-label="required"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.bio}
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="version">
                                            <abbr aria-label="required"> Version</abbr>
                                            <strong style={{ color: "red" }}> *</strong>
                                        </label>
                                        <div className="col-sm-4">
                                            <select
                                                type="text"
                                                id="version"
                                                name="version"
                                                title="required"
                                                aria-label="required"
                                                autoComplete='off'
                                                //   onKeyUp={changeCase}
                                                required
                                                value={state.version}
                                                onChange={handleChange}
                                                className="form-control">
                                                <option value="16.8">v16.8.0</option>
                                                <option value="16.7">v16.7.0</option>
                                                <option value="16.6">v16.6.0</option>
                                                <option value="16.5">v16.5.0</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="selectedLevel">
                                            <abbr aria-label="required"> Level</abbr>
                                            <strong style={{ color: "red" }}> *</strong></label>
                                        <div className="col-sm-4">
                                            <label>
                                                <input
                                                    type="radio"
                                                    id='selectedLevel'
                                                    name='selectedLevel'
                                                    value="Male"
                                                    checked={state.selectedLevel === "Male"}
                                                    onChange={handleChecked}
                                                />
                                                Male
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    id='selectedLevel'
                                                    name='selectedLevel'
                                                    value="Female"
                                                    checked={state.selectedLevel === "Female"}
                                                    onChange={handleChecked}
                                                />
                                                Female
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    id='selectedLevel'
                                                    name='selectedLevel'
                                                    value="Other"
                                                    checked={state.selectedLevel === "Other"}
                                                    onChange={handleChecked}
                                                />
                                                Other
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="hooks">
                                            <abbr aria-label="required"> With hooks</abbr>
                                            <strong style={{ color: "red" }}></strong>
                                            <input
                                                type="checkbox"
                                                id="hooks"
                                                name="hooks"
                                                checked={state.hooks}
                                                onChange={handleChecked}
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-footer">
                                <button type="submit"
                                    className="btn btn-success">Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className="box-footer">user information</div>
                </div>
            </section>
        </>
    )
}

export default ChangeForm